<template>
  <div class="chat-token botter--widget">
    <div class="chat-token--attributes" v-if="chatAttributes.length">
      <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(n, k) in chatAttributes" :key="Object.keys(n[0])[0]">
          <div class="attributes-wrapper">
            <div class="attributes-token" v-for="i in n" :key="Object.keys(i)[0]">
              <span style="text-transform: capitalize">{{Object.keys(i)[0].split('_').join(' ')}}:</span>
              <span :class="[{ 'error--text': !(i[Object.keys(i)[0]]) }]">{{i[Object.keys(i)[0]] || 'none'}}</span>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="custom-swiper-navigation">
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </div>
    <div class="chat-token--content botter-wdiget-body">
      <section v-for="msg in msgsData" :key="msg._id">
        <bot-msg :msg="msg" />
      </section>
    </div>
  </div>
</template>
<script>
import UserMsg from "../../components/chat-history/user-msg";
import BotMsg from "../../components/chat-history/bot-msg";

export default {
  name: 'chatHistoryPreview',
  components: { UserMsg, BotMsg },
  props: ["chatData", "chatAttrs"],
  data() {
    return {
      msgsData: [],
      swiperOptions: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      chatAttributes: []
    };
  },
  computed: {
    // msgsData() {
    //   // console.log(this.chatData, " chatData");
    //   return this.chatData;
    // }
  },
  created() {
    if (this.chatAttrs) {
      this.parseAttrs(this.chatAttrs);
    }
  },
  mounted() {},
  methods: {
    parseAttrs(attrs) {
      const attributes = JSON.parse(attrs);
      const mappedAttributes = Object.entries(attributes).map(i => {
        let hol = {};
        hol[i[0]] = i[1];
        return hol;
      });
      this.chatAttributes = [...this.chunk(mappedAttributes, 5)];
      // console.log(this.chunk(mappedAttributes, 3));
    },
    chunk(array, size) {
      const chunked_arr = [];
      for (let i = 0; i < array.length; i++) {
        const last = chunked_arr[chunked_arr.length - 1];
        if (!last || last.length === size) {
          chunked_arr.push([array[i]]);
        } else {
          last.push(array[i]);
        }
      }
      return chunked_arr;
    }
  },
  watch: {
    chatAttrs(val) {
      if (val) {
        this.parseAttrs(val);
      } else {
        this.chatAttributes = [...[]];
      }
    },
    chatData: {
      deep: true,
      handler(val) {
        // console.log(val, before)
        if (val && val.length) {
          this.msgsData = []
          // setTimeout(()=>{
            this.msgsData = val
          // }, 500)
        } else this.msgsData = []
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.chat-token {
  font-family: "GT-Walsheim-Pro-Regular" !important;
  // height: calc(100vh - 200px);
  // overflow-y: auto;
  // border-radius: 8px;
  // background-color: #ffffff;
  height: 100%;
  &--attributes {
    padding: 28px 24px;
    border-bottom: 1px solid #e2e2ea;
    position: relative;
    // height: 170px;
    .attributes-wrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .attributes-token {
        width: 49%;
        margin-bottom: 1rem;
        span:first-of-type {
          font-size: 16px;
          font-weight: bold;
          color: #171725;
        }
        span:last-of-type {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.51);
          margin: 0 1rem;
        }
      }
    }
  }
  &--content {
    padding: 28px 24px;
    // width: 500px;
  }
}

.swiper {
  // height: 170px;
  width: 1000px;
  margin: unset !important;
  .swiper-slide {
    display: flex;
  }
}
.custom-swiper-navigation {
  position: relative;
  width: 100px;
  margin-left: auto;
}
.swiper-button-prev:focus,
.swiper-button-next:focus {
  outline: none;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 20px;
  color: #92929d;
  font-weight: bold;
}

</style>
